import { createThunklessAction } from 'thunkless';

import { avo } from '@/api/app/avo-client';
import { demoUsersFetchStatusSelector } from '../selectors/analytics';

export enum AnalyticsTypes {
  FETCH_DEMO_USERS_REQUEST = 'app/analytics/FETCH_DEMO_USERS_REQUEST',
  FETCH_DEMO_USERS_SUCCESS = 'app/analytics/FETCH_DEMO_USERS_SUCCESS',
  FETCH_DEMO_USERS_FAILURE = 'app/analytics/FETCH_DEMO_USERS_FAILURE',
}

export const fetchDemoUsers = (subdomain: string) => createThunklessAction({
  type: [
    AnalyticsTypes.FETCH_DEMO_USERS_REQUEST,
    AnalyticsTypes.FETCH_DEMO_USERS_SUCCESS,
    AnalyticsTypes.FETCH_DEMO_USERS_FAILURE,
  ] as const,
  promise: () => avo.ajax<{ users: any }>({
    method: 'GET',
    route: '/v1/analytics/demo_users',
    params: { subdomain },
  }),
  statusSelector: demoUsersFetchStatusSelector,
});